import React from 'react'
import './ContactUs.css'
import Steps from '../components/Steps'
import Reviews from '../components/Reviews'

function ContactUs() {
  return (
    <div>
        <div className='contact-hero-section'>
        </div>

        <div className='contact-section'>
          <div className='contact-item'>
            <h2 className='header3'>Contact Us: info@malaikadoula.com</h2>
            <h2 className='header3'>Better yet, see us in person!</h2>
            <p className='grey'>We love our customers and are dedicated to providing compassionate pregnancy support. Feel free to visit us during normal business hours to learn more about our expert care for pregnancy and doula services.</p>
            <h2 className='header3'>Malaika Doula Service LLC</h2>
            <p className='grey'>2393 Fernwood Lane, Brentwood, CA, USA</p>
            <p className='grey'>(925) 844 3054</p>
            <h2 className='header3'>Hours</h2>
            <div className='grey'>
              <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
            <p>Saturday: Closed</p>
            <p>Sunday: Closed</p>
            </div>
          </div>

          <div className='contact-item'>
            <iframe
              title="Malaika Doula Service Location"
              width="100%"
              height="400"
              frameBorder="0"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3177.5234567890!2d-121.7!3d37.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808559c5c5c5c5c5%3A0x0!2s2393%20Fernwood%20Ln%2C%20Brentwood%2C%20CA%2094513!5e0!3m2!1sen!2sus!4v1234567890"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <Steps />
        <Reviews />
    </div>
  )
}

export default ContactUs